<template>
  <div class="form-group" :class="formGroupClass" v-if="page === 'modal'">
    <label :class="recommendation ? 'text-left d-block mb-2 mb-lg-0' : ''">{{ label }}</label>
    <small class="text-muted font-italic">{{ recommendation }}</small>
    <app-input
        :type="type"
        v-model="model"
        @input="$emit('input', $event)"
        v-bind="propsFor()"
        :error-message="errorMessage"
        :label="fileLabel"
        :id="id || $vnode.data.model.expression"
        v-on="$listeners"
        :name="name"
        autocomplete="false"
        v-if="!isCustomInput"
    />
    <app-custom-tag-input
        v-else
        :id="id"
        :tags="model"
        @update-tags="handleTagsUpdate"
    />
    <slot name="suggestion"></slot>
  </div>
  <div class="form-group" :class="formGroupClass" v-else-if="page === 'page'">
    <div :class="`row ${labelAlignment === 'center' ? 'align-items-center' : ''}`">
      <div class="col-lg-8 col-xl-8 col-md-8 col-sm-12 mb-2">
        <label class="text-left d-block mb-lg-0">
          {{ label }}
          <br v-if="recommendation" />
          <small v-if="recommendation" class="text-muted font-italic"> {{ recommendation }} </small>
        </label>
      </div>
      <div class="col-lg-9 col-xl-9 col-md-9 col-sm-12">
        <app-input
            :type="type"
            v-model="model"
            @input="$emit('input', $event)"
            v-bind="propsFor()"
            :error-message="errorMessage"
            :label="fileLabel"
            :id="id || $vnode.data.model.expression"
            v-on="$listeners"
            autocomplete="false"
            v-if="!isCustomInput"
        />
        <app-custom-tag-input
            v-else
            :id="id"
            :tags="model"
            @update-tags="handleTagsUpdate"
        />
        <slot name="suggestion"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../core/mixins/form/FormMixin";
import _ from "lodash";
import { kebabCase } from "../../Helper/Support/TextHelper";

export default {
  name: "FormGroup",
  mixins: [FormMixin],
  props: {
    type: { type: String, default: "text" },
    name: { type: String, default: "" },
    label: { type: String, required: true },
    value: { required: true },
    page: { default: "modal" },
    errorMessage: { type: String, default: "" },
    recommendation: {},
    fileLabel: {},
    formGroupClass: { type: String },
    id: { type: String, default: "" },
    labelAlignment: { type: String, default: "center" },
    customInput: { type: Boolean, default: false }, // To identify if it’s a custom input like tag input
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      model: "",
    };
  },
  computed: {
    inputType() {
      return this.customInput ? "app-custom-tag-input" : "app-input";
    },
    isCustomInput() {
      return this.customInput;
    },
  },
  methods: {
    propsFor() {
      let props = this.$attrs;
      props.required = this.required;
      const cTor = this.$options.components["app-input"];
      if (cTor) {
        let keys = Object.keys(cTor.options.props);
        if (!keys.includes("required")) keys.push("required");
        return _.pick(props, keys.map((key) => kebabCase(key)));
      }
    },
    handleTagsUpdate(tags) {
      this.model = tags;
      this.$emit("input", tags);
    },
  },
  watch: {
    value: {
      handler: function (value) {
        this.model = value;
      },
      immediate: true,
    },
    errorMessage: {
      handler: function (errorMessage) {
        if (errorMessage) {
          this.fieldStatus.isSubmit = true;
        }
      },
      immediate: true,
    },
  },
};
</script>
